import { render } from "./PasswordReset.vue?vue&type=template&id=7832182a&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=7832182a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7832182a"

export default script